import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

/**
 * Stable key for toggling inline expansion of an ATC/RS group.
 *
 * @param {string} groupId the group identifier.
 * @returns {string} the expand key.
 */
export function availabilityGroupExpandKey(groupId: string): string {
	return groupId;
}

/**
 * Collects expand keys for every group on the current page.
 *
 * @param {CzechSuklRsAtcGroupResponse[]} groups the groups on the current page.
 * @returns {Set<string>} expand keys for each group.
 */
export function collectPageExpandKeys(groups: CzechSuklRsAtcGroupResponse[]): Set<string> {
	return new Set(groups.map((group) => availabilityGroupExpandKey(group.id)));
}
